import { GetServerSideProps } from 'next';
import { useParams } from 'next/navigation';
import { useContext, useEffect } from 'react';

import PacksList from '@/components/app/cards/PacksList';
import { PacksContext } from '@/components/app/layout/PacksProvider';
import Layout from '@/components/layout/LayoutWrapper';
import { usePacksClass } from '@/hooks/app/usePacksClass';
import { useRouterPush } from '@/hooks/utils/useRouterPush';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const PacksClass = () => {
	const params = useParams();
	const routerPush = useRouterPush();
	const packClassName = typeof params?.className === 'string' ? params.className : undefined;
	const { pack, isLoading } = usePacksClass(packClassName);
	const { setPageTitle } = useContext(PacksContext);

	useEffect(() => {
		setPageTitle(null);
	}, [pack, setPageTitle]);

	if (!pack && !isLoading) {
		routerPush('/404');
		return null;
	}

	return (
		<Layout pageName={`pack-class-${packClassName}`}>
			<PacksList packs={pack ? [pack] : []} isLoading={isLoading} />
		</Layout>
	);
};

export default PacksClass;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState: {
				...initialState,
				tags: [],
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
